import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthFetch } from '../hooks/useAuthFetch';
import { showSuccess, showError } from '../utils/toastUtils';
import '../stili/Notizie.css';

const API_URL = process.env.REACT_APP_API_URL;

export default function Notizie() {
  const authFetch = useAuthFetch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    titolo: '',
    contenuto: '',
    autore: '',
    dataPubblicazione: '',
    stato: 'BOZZA'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === 'contenuto' || name === 'dataPubblicazione' || name === 'stato'
          ? value
          : value.toUpperCase()
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        titolo: formData.titolo,
        contenuto: formData.contenuto,
        autore: formData.autore,
        stato: formData.stato,
        dataPubblicazione: formData.dataPubblicazione || null
      };

      const res = await authFetch(`${API_URL}/api/admin/notizie`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        let msg = "Errore nell'inserimento notizia";
        try {
          const err = await res.json();
          msg = err.message || msg;
        } catch {}
        throw new Error(msg);
      }

      showSuccess('✅ Notizia inserita con successo!');
      setFormData({
        titolo: '',
        contenuto: '',
        autore: '',
        dataPubblicazione: '',
        stato: 'BOZZA'
      });
    } catch (err) {
      showError(err.message);
    }
  };

  return (
  <div className="notizie-container" translate="no">
    <h2 className="notizie-title">Inserisci Nuova Notizia</h2>

    <div className="notizie-card">
      <div className="notizie-section">
        <h3 className="notizie-section-title">Dati Notizia</h3>

        <form onSubmit={handleSubmit}>
          <div className="notizie-grid-2">

            <div className="notizie-form-group">
              <label className="notizie-label" htmlFor="titolo">
                Titolo
              </label>
              <input
                className="notizie-input"
                id="titolo"
                type="text"
                name="titolo"
                value={formData.titolo}
                onChange={handleChange}
                placeholder="Titolo notizia"
                required
              />
            </div>

            <div className="notizie-form-group">
              <label className="notizie-label" htmlFor="autore">
                Autore
              </label>
              <input
                className="notizie-input"
                id="autore"
                type="text"
                name="autore"
                value={formData.autore}
                onChange={handleChange}
                placeholder="Autore notizia"
                required
              />
            </div>

            <div className="notizie-form-group">
              <label className="notizie-label" htmlFor="dataPubblicazione">
                Data pubblicazione
              </label>
              <input
                className="notizie-input"
                id="dataPubblicazione"
                type="date"
                name="dataPubblicazione"
                value={formData.dataPubblicazione}
                onChange={handleChange}
              />
            </div>

            <div className="notizie-form-group">
              <label className="notizie-label" htmlFor="stato">
                Stato
              </label>
              <select
                className="notizie-select"
                id="stato"
                name="stato"
                value={formData.stato}
                onChange={handleChange}
                required
              >
                <option value="BOZZA">BOZZA</option>
                <option value="PUBBLICATA">PUBBLICATA</option>
                <option value="NASCOSTA">NASCOSTA</option>
              </select>
            </div>

            <div className="notizie-form-group notizie-full-width">
              <label className="notizie-label" htmlFor="contenuto">
                Contenuto
              </label>
              <textarea
                className="notizie-textarea"
                id="contenuto"
                name="contenuto"
                value={formData.contenuto}
                onChange={handleChange}
                placeholder="Contenuto notizia"
                required
              />
            </div>

          </div>

          <div className="notizie-button-row">
            <button className="notizie-btn-primary" type="submit">
              Crea Notizia
            </button>

            <button
              className="notizie-btn-secondary"
              type="button"
              onClick={() => navigate('/gestionale')}
            >
              Torna al Gestionale
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
);
}